<app-patient-info [heading]="Item"></app-patient-info>
<p-tabView [(activeIndex)]="activeIndex">
  <p-tabPanel header="Charges">
    <form [formGroup]="billingform" (ngSubmit)="submitcharges()">
      <div class="p-fluid grid charges">
        <div class="field col-12 md:col-4">
          <span class="p-float-label">
            <p-panel header="Facility:" class="BillingHeader">
              <p-dropdown
                *ngIf="facilityList"
                dataKey="facilityID"
                [options]="facilityList"
                formControlName="facility"
                appFormErrorMessages
                placeholder="--Select--"
                optionLabel="facilityName"
                class="ui-fluid"
              ></p-dropdown>
            </p-panel>
          </span>
        </div>
        <div class="field col-12 md:col-4">
          <span class="p-float-label">
            <p-panel header="Referring:" class="BillingHeader">
              <p-dropdown
                *ngIf="referringList"
                dataKey="referringId"
                [options]="referringList"
                formControlName="reference"
                appFormErrorMessages
                placeholder="--Select--"
                optionLabel="referringName"
                class="ui-fluid"
                [showClear]="true"
              ></p-dropdown>
            </p-panel>
          </span>
        </div>
        <div class="field col-12 md:col-4">
          <span class="p-float-label">
            <p-panel header="Physician:" class="BillingHeader">
              <p-dropdown
                *ngIf="physicianList"
                dataKey="physicianId"
                [options]="physicianList"
                formControlName="physician"
                appFormErrorMessages
                placeholder="--Select--"
                optionLabel="physicianName"
                class="ui-fluid"
                         
              ></p-dropdown>
            </p-panel>
          </span>
        </div>
      </div>
      <div class="p-fluid grid charges">
        <div class="field col-12 md:col-4">
          <span class="p-float-label">
            <p-panel header="Last Appointment:" class="BillingHeader">
              <input
                readonly="readonly"
                id="txtlastApptDate"
                type="text"
                pInputText
                formControlName="lastApptDate"
              />
            </p-panel>
          </span>
        </div>
        <div class="field col-12 md:col-4">
          <span class="p-float-label">
            <p-panel header="Next Appointment:" class="BillingHeader">
              <input
                readonly="readonly"
                id="txtnextApptDate"
                type="text"
                pInputText
                formControlName="nextApptDate"
              />
            </p-panel>
          </span>
        </div>
        <div class="field col-12 md:col-4">
          <span class="p-float-label">
            <p-panel header="Service Date:" class="BillingHeader">
              <p-calendar
                formControlName="serviceDate"
                [readonlyInput]="true"
                showButtonBar="true"
                [showIcon]="true"
                styleClass="myWid70"
              ></p-calendar>
            </p-panel>
          </span>
        </div>
      </div>
      <div class="p-fluid grid col-12">
          <div class="col-12 md:col-4">
              <div class="floatL col-4 md:col-4">
                  <p-panel header="Select Type:" class="BillingHeader">
                      <p-radioButton name="status"
                                     value="{{ InpatientLabelName }}"
                                     class="mr-2"
                                     label="{{ InpatientLabelName }}"
                                     inputId="rbinpt"
                                     formControlName="status"
                                     (onClick)="setSelection('1')"></p-radioButton>
                  </p-panel>
              </div>

              <div class="floatL col-4 md:col-4 pt-4">
                  <p-panel class="">
                      <p-radioButton name="status"
                                     value="{{ OutpatientLabelName }}"
                                     class="mr-2"
                                     label="{{ OutpatientLabelName }}"
                                     inputId="rbotpt"
                                     formControlName="status"
                                     (onClick)="setSelection('2')"></p-radioButton>
                  </p-panel>
              </div>

              <div class="floatL col-4 md:col-4 pt-4">
                  <p-panel class="">
                      <p-radioButton name="status"
                                     value="{{ OfficeLabelName }}"
                                     label="{{ OfficeLabelName }}"
                                     inputId="rboff"
                                     formControlName="status"
                                     (onClick)="setSelection('3')"></p-radioButton>
                  </p-panel>
              </div>
          </div>

          <div class="field col-12 md:col-4 charges">
              <span class="p-float-label">
                  <p-panel header="Procedure Description:" class="BillingHeader">
                      <div class="p-inputgroup" data-pc-name="inputgroup">
                          <input readonly="readonly" id="float-input" type="text" placeholder="Procedure:" appFormErrorMessages pInputText formControlName="procedureName" />
                          <button type="button" pbutton=""
                                  pripple="" icon="pi pi-ellipsis-v" class="p-element p-ripple p-button p-component" (click)="setprocedure('1', 'R')" style="border-top-right-radius: 4px; border-bottom-right-radius: 4px;">
                              <span class="p-button-label"><i class="pi pi-list"></i></span><span class="p-ink" aria-hidden="true" role="presentation"></span>
                          </button>

                      </div>
                  </p-panel>
              </span>
          </div>


          <div class="field col-12 md:col-4 charges">
              <span class="p-float-label">
                  <p-panel header="Procedure Code:" class="BillingHeader">
                      <div class="p-inputgroup" data-pc-name="inputgroup">

                          <input id="float-hidden" type="text" appFormErrorMessages pInputText formControlName="procedureId" readonly="readonly" />
                          <button type="button" pbutton="" pripple="" icon="pi pi-list" class="p-element p-ripple p-button p-component"
                                  (click)="setprocedure('1', 'R')"
                                  style="border-top-right-radius: 4px; border-bottom-right-radius: 4px;">
                              <span class="p-button-label"><i class="pi pi-list"></i></span><span class="p-ink" aria-hidden="true" role="presentation"></span>
                          </button>
                      </div>
                  </p-panel>
              </span>
          </div>





      </div>
      <div class="grid charges pt-3">
        <div class="col-6 md:col-3">
          <div class="p-inputgroup charges" data-pc-name="inputgroup">
            <input
              readonly="readonly"
              id="float-input"
              type="text"
              placeholder="Diagnosis1:"
              pInputText
              formControlName="diag1"
              (click)="setdiagnosis('1', 'RD')"
            />
            <button
              type="button"
              pbutton=""
              pripple=""
              icon="pi pi-list"
              class="p-element p-ripple p-button p-component"
              (click)="setdiagnosis('1', 'R')"
            >
              <span class="p-button-label"><i class="pi pi-list"></i></span
              ><span
                class="p-ink"
                aria-hidden="true"
                role="presentation"
              ></span>
            </button>
          </div>
        </div>
        <div class="col-6 md:col-3">
          <div class="p-inputgroup" data-pc-name="inputgroup">
            <input
              readonly="readonly"
              id="float-input"
              type="text"
              placeholder="Diagnosis2:"
              pInputText
              formControlName="diag2"
              (click)="setdiagnosis('2', 'RD')"
            />
            <button
              type="button"
              pbutton=""
              pripple=""
              icon="pi pi-list"
              class="p-element p-ripple p-button p-component"
              (click)="setdiagnosis('2', 'R')"
            >
              <span class="p-button-label"><i class="pi pi-list"></i></span
              ><span
                class="p-ink"
                aria-hidden="true"
                role="presentation"
              ></span>
            </button>
          </div>
        </div>
        <div class="col-6 md:col-3">
          <div class="p-inputgroup" data-pc-name="inputgroup">
            <input
              readonly="readonly"
              id="float-input"
              type="text"
              placeholder="Diagnosis3:"
              pInputText
              formControlName="diag3"
              (click)="setdiagnosis('3', 'RD')"
            />
            <button
              type="button"
              pbutton=""
              pripple=""
              icon="pi pi-list"
              class="p-element p-ripple p-button p-component"
              (click)="setdiagnosis('3', 'R')"
            >
              <span class="p-button-label"><i class="pi pi-list"></i></span
              ><span
                class="p-ink"
                aria-hidden="true"
                role="presentation"
              ></span>
            </button>
          </div>
        </div>
        <div class="col-6 md:col-3">
          <div class="p-inputgroup" data-pc-name="inputgroup">
            <input
              readonly="readonly"
              id="float-input"
              type="text"
              placeholder="Diagnosis4:"
              pInputText
              formControlName="diag4"
              (click)="setdiagnosis('4', 'RD')"
            />
            <button
              type="button"
              pbutton=""
              pripple=""
              icon="pi pi-list"
              class="p-element p-ripple p-button p-component"
              (click)="setdiagnosis('4', 'R')"
            >
              <span class="p-button-label"><i class="pi pi-list"></i></span
              ><span
                class="p-ink"
                aria-hidden="true"
                role="presentation"
              ></span>
            </button>
          </div>
        </div>
      </div>

            <div class="grid charges pt-3">
                <div class="col-6 md:col-3">
                    <div class="p-inputgroup" data-pc-name="inputgroup">
                        <input readonly="readonly"
                               id="float-input"
                               type="text"
                               placeholder="Diagnosis5:"
                               pInputText
                               formControlName="diag5"
                               (click)="setdiagnosis('5', 'RD')" />
                        <button type="button"
                                pbutton=""
                                pripple=""
                                icon="pi pi-list"
                                class="p-element p-ripple p-button p-component"
                                (click)="setdiagnosis('5', 'R')">
                            <span class="p-button-label"><i class="pi pi-list"></i></span><span class="p-ink"
                                                                                                aria-hidden="true"
                                                                                                role="presentation"></span>
                        </button>
                    </div>
                </div>
                <div class="col-6 md:col-3">
                    <div class="p-inputgroup" data-pc-name="inputgroup">
                        <input readonly="readonly"
                               id="float-input"
                               type="text"
                               placeholder="Diagnosis6:"
                               pInputText
                               formControlName="diag6"
                               (click)="setdiagnosis('6', 'RD')" />
                        <button type="button"
                                pbutton=""
                                pripple=""
                                icon="pi pi-list"
                                class="p-element p-ripple p-button p-component"
                                (click)="setdiagnosis('6', 'R')">
                            <span class="p-button-label"><i class="pi pi-list"></i></span><span class="p-ink"
                                                                                                aria-hidden="true"
                                                                                                role="presentation"></span>
                        </button>
                    </div>
                </div>
                <div class="col-6 md:col-3">
                    <div class="p-inputgroup" data-pc-name="inputgroup">
                        <input readonly="readonly"
                               id="float-input"
                               type="text"
                               placeholder="Diagnosis7:"
                               pInputText
                               formControlName="diag7"
                               (click)="setdiagnosis('7', 'RD')" />
                        <button type="button"
                                pbutton=""
                                pripple=""
                                icon="pi pi-list"
                                class="p-element p-ripple p-button p-component"
                                (click)="setdiagnosis('7', 'R')">
                            <span class="p-button-label"><i class="pi pi-list"></i></span><span class="p-ink"
                                                                                                aria-hidden="true"
                                                                                                role="presentation"></span>
                        </button>
                    </div>
                </div>
                <div class="col-6 md:col-3">
                    <div class="p-inputgroup" data-pc-name="inputgroup">
                        <input readonly="readonly"
                               id="float-input"
                               type="text"
                               placeholder="Diagnosis8:"
                               pInputText
                               formControlName="diag8"
                               (click)="setdiagnosis('8', 'RD')" />
                        <button type="button"
                                pbutton=""
                                pripple=""
                                icon="pi pi-list"
                                class="p-element p-ripple p-button p-component"
                                (click)="setdiagnosis('8', 'R')">
                            <span class="p-button-label"><i class="pi pi-list"></i></span><span class="p-ink"
                                                                                                aria-hidden="true"
                                                                                                role="presentation"></span>
                        </button>
                    </div>
                </div>
            </div>

            <div class="p-fluid grid pt-3">
                <div class="field col-6 md:col-3">
                    <span class="p-float-label p-fluid">
                        <input id="float-input"
                               type="text"
                               pInputText
                               formControlName="mod1"
                               autocomplete="off" />

                        <label for="float-input">Modifiers1:</label>
                    </span>
                </div>
                <div class="field col-6 md:col-3">
                    <span class="p-float-label p-fluid">
                        <input id="float-input"
                               type="text"
                               pInputText
                               formControlName="mod2"
                               autocomplete="off" />

                        <label for="float-input">Modifiers2:</label>
                    </span>
                </div>
                <div class="field col-6 md:col-3">
                    <span class="p-float-label p-fluid">
                        <input id="float-input"
                               type="text"
                               pInputText
                               formControlName="mod3"
                               autocomplete="off" />

                        <label for="float-input">Modifiers3:</label>
                    </span>
                </div>
                <div class="field col-6 md:col-3">
                    <span class="p-float-label p-fluid">
                        <input id="float-input"
                               type="text"
                               pInputText
                               formControlName="mod4"
                               autocomplete="off" />

                        <label for="float-input">Modifiers4:</label>
                    </span>
                </div>
            </div>

            <button pButton
                    type="submit"
                    label="Submit Charges"
                    icon="pi pi-check"
                    style="margin-right: 0.5em"></button>
        </form>

        <hr />
        <p-table #dt
                 *ngIf="billingsummary"
                 [responsive]="true"
                 [columns]="cols"
                 [value]="billingsummary.data"
                 selectionMode="single"
                 dataKey="billingID"
                 [resetPageOnSort]="false"
                 [lazy]="false"
                 [rows]="rows"
                 [paginator]="billingsummary?.data.length > 0"
                 [autoLayout]="true"
                 [draggable]="true"
                 positionType="absolute">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th></th>
                    <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                        {{ col.header }}
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body"
                         let-rowData
                         let-columns="columns"
                         let-i="rowIndex">
                <tr [pSelectableRow]="rowData">
                    <td>
                        <button pButton
                                type="button"
                                icon="pi pi-info"
                                class="ui-button-success"
                                style="font-size: 0.7em"
                                (click)="getbillingDetails(rowData['billingID'])"></button>
                    </td>

                    <td *ngFor="let col of columns">
                        {{ rowData[col.field] }}
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage" let-columns="columns">
                <tr>
                    <td colspan="12" class="Colspan-Bg">
                        <div class="w-12 bg-white">
                            <div class="" style="text-align: center">
                                <img _ngcontent-ng-c683320295=""
                                     class="profile-image"
                                     style="border-radius: 50%; width: 10rem; padding-top: 1rem"
                                     src="assets/imagesNew/table_error.png" />
                            </div>
                            <hr style="margin-bottom: 0.5rem" />
                            <div class=""
                                 style="text-align: center; font-size: larger; color: #1d428f">
                                <i>No records found</i>
                            </div>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                <span *ngIf="state.totalRecords > pageSize">
                    Showing {{ state.page * state.rows + 1 }} to
                    {{ state.rows * (state.page + 1) }} of {{ state.totalRecords }} records.
                </span>
            </ng-template>
        </p-table>
    </p-tabPanel>

    <p-dialog [(visible)]="displaypopup"
              [draggable]="true"
              [modal]="true"
              positionType="absolute"
              [style]="{ width: '25vw' }"
              [baseZIndex]="10000"
              [maximizable]="true">
        <p-header>
            {{ popupheader }}
        </p-header>

        <div class="p-fluid" style="padding-left: 10px">
            <ng-container *ngFor="let category of clinicalTemplate">
                <div class="mb-4">
                    <h5 style="background-color: #1d428f; color: snow" class="p-1 mb-0">
                        {{ category.codeSets[0].categoryName }}
                    </h5>
                    <table class="table table-bordered table-striped table-hover WMax">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Name</th>
                                <th>Code</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let item of category.codeSets; let i = index">
                                <tr *ngFor="let name of item.names; let j = index"
                                    [class]="j % 2 === 0 ? 'even-row' : 'odd-row'">
                                    <td>
                                        <p-radioButton [inputId]="name"
                                                       name="name"
                                                       [value]="item.testCodes[j]"
                                                       [(ngModel)]="selectedCategory"
                                                       (onClick)="SelectProcedure(name, item.testCodes[j])"></p-radioButton>
                                    </td>
                                    <td>{{ name }}</td>
                                    <td>{{ item.testCodes[j] }}</td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </ng-container>
        </div>

        <p-footer style="display: flex; justify-content: center">
            <button pButton
                    type="button"
                    icon="pi pi-times-circle"
                    (click)="displaypopup = false"
                    label="Cancel"
                    class="ui-button-secondary"></button>
        </p-footer>
    </p-dialog>

    <p-dialog [(visible)]="diagdisplaypopup"
              [draggable]="false"
              [modal]="true"
              positionType="absolute"
              [style]="{ width: '50vw' }"
              [baseZIndex]="10000"
              [maximizable]="true">
        <p-header>
            <h3>{{ popupheader }} </h3>
        </p-header>

        <div class="card pb-0">
            <div class="grid" *ngIf="showsearchdiag == true">
                <div class="field col-12 md:col-3">
                    <span class="p-float-label">
                        <input id="float-input"
                               [(ngModel)]="diagcode"
                               type="text"
                               pInputText
                               class="WMax"
                               autocomplete="off" />
                        <label for="float-input" style="width: max-content">Code</label>
                    </span>
                </div>

                <div class="field col-12 md:col-3 pr-3">
                    <span class="p-float-label">
                        <input id="float-input"
                               [(ngModel)]="diagdesc"
                               type="text"
                               pInputText
                               class="WMax"
                               autocomplete="off" />
                        <label for="float-input">Description</label>
                    </span>
                </div>
                <div class="field col-12 md:col-5">
                    <button pButton
                            type="button"
                            icon="pi pi-search"
                            label="Search"
                            (click)="getrecentdiagnosis()"
                            class="ui-button-plain buttonWidth-8 fl mr-2"></button>
                    <p-button label="Clear"
                              severity="secondary"
                              (click)="clearSearch()"
                              icon="pi pi-refresh"
                              class="ui-button-plain buttonWidth-8 fl"></p-button>
                </div>
            </div>
        </div>

        <!--<p-table [value]="diagsummary?.data" [columns]="diagcols"
                     selectionMode="single"
                     (onRowSelect)="onRowSelect($event)">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" [pSortableColumn]="col.field" class="col-12 md:col-2">
                            {{col.header}}

                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr [pSelectableRow]="rowData">
                        <td *ngFor="let col of columns" [hidden]="col.hidden">
                            {{rowData[col.field]}}
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns="columns">
                    <tr>
                        <td colspan="12" class="Colspan-Bg">
                            <div class="w-12 bg-white">
                                <div class="" style="text-align: center;">
                                    <img _ngcontent-ng-c683320295="" class="profile-image" style="border-radius: 50%; width: 10rem; padding-top: 1rem; " src="assets/imagesNew/table_error.png">
                                </div>
                                <hr style="margin-bottom: 0.5rem;" />
                                <div class="" style="text-align: center; font-size: larger; color: #1d428F; ">
                                    <i>No Records found.</i>
                                </div>
                            </div>
                        </td>
                    </tr>

                </ng-template>
            </p-table>-->
        <!---              -->

        <p-table *ngIf="diagsummary"
                 [responsive]="true"
                 [columns]="diagcols"
                 [value]="diagsummary.data"
                 selectionMode="single"
                 dataKey="allergyId"
                 [resetPageOnSort]="false"
                 [lazy]="false"
                 [rows]="rows"
                 [paginator]="showRecords"
                 [customSort]="true"
                 (sortFunction)="customSort($event, 1)"
                 (onRowSelect)="onRowSelect($event)">
            <ng-template pTemplate="header" let-columns>
                <tr *ngIf="showRecords == true">
                    <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                        {{ col.header }}
                        <p-sortIcon [field]="col.field"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body"
                         let-rowData
                         let-columns="columns"
                         let-i="rowIndex">
                <tr [pSelectableRow]="rowData">
                    <td *ngFor="let col of columns">
                        {{ rowData[col.field] }}
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <div class="w-12 bg-white">
                    <div class="" style="text-align: center">
                        <img _ngcontent-ng-c683320295=""
                             class="profile-image"
                             style="border-radius: 50%; width: 10rem; padding-top: 1rem"
                             src="assets/imagesNew/table_error.png" />
                    </div>
                    <hr style="margin-bottom: 0.5rem" />
                    <div class=""
                         style="text-align: center; font-size: larger; color: #1d428f">
                        <i>No records found</i>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                Showing {{ state.page * state.rows + 1 }} to
                {{ state.rows * (state.page + 1) }} of {{ state.totalRecords }} records.
            </ng-template>
        </p-table>

        <!------------------------------>

        <div *ngIf="diagsummary?.data && diagsummary.data.length > 0">
            <p-footer style="display: flex; justify-content: center">
                <button pButton
                        type="button"
                        icon="pi pi-times-circle"
                        (click)="cancelDiagSummPopUp()"
                        label="Cancel"
                        class="p-button-plain"></button>
            </p-footer>
        </div>
    </p-dialog>

    <p-dialog [(visible)]="displaypopup_procedure"
              [draggable]="true"
              [modal]="true"
              positionType="absolute"
              [style]="{ width: '50vw' }"
              [baseZIndex]="10000"
              [maximizable]="true">
        <p-header>
            {{ popupheader_procedure }}
        </p-header>

        <div class="p-fluid grid">
            <div class="field-checkbox col-12 md:col-3"
                 *ngFor="let category of clinicalTemplate">
                <p-radioButton [inputId]="category.text"
                               name="category"
                               [value]="category"
                               [(ngModel)]="selectedCategory"
                               (onClick)="SelectProcedure(category.text, category.value)"></p-radioButton>
                <label [for]="category.value">{{ category.text }}</label>
            </div>
        </div>
        <p-footer style="display: flex; justify-content: center">
            <button pButton
                    type="button"
                    icon="pi pi-times-circle"
                    (click)="displaypopup = false"
                    label="Cancel"
                    class="ui-button-secondary"></button>
        </p-footer>
    </p-dialog>

    <p-dialog [(visible)]="procedure_displaypopup"
              [draggable]="true"
              [modal]="true"
              positionType="absolute"
              [style]="{ width: '50vw' }"
              [baseZIndex]="10000"
              [maximizable]="true">
        <p-header>
            <h3>{{ popupheader_procedure }}</h3>
        </p-header>

        <div class="card pb-0">
            <div class="grid" *ngIf="showsearch_proc == true">
                <div class="field col-12 md:col-3">
                    <span class="p-float-label">
                        <input id="float-input"
                               [(ngModel)]="procCode"
                               type="text"
                               pInputText
                               class="Wmax"
                               autocomplete="off" />
                        <label for="float-input" style="width: max-content">Code</label>
                    </span>
                </div>

                <div class="field col-12 md:col-3">
                    <span class="p-float-label">
                        <input id="float-input"
                               [(ngModel)]="procDesc"
                               type="text"
                               pInputText
                               class="WMax"
                               autocomplete="off" />
                        <label for="float-input">Description</label>
                    </span>
                </div>

                <div class="field col-12 md:col-5 pr-3">
                    <button pButton
                            type="button"
                            icon="pi pi-search"
                            label="Search"
                            (click)="getprocedureSearch()"
                            class="ui-button-plain buttonWidth-8 fl mr-2"></button>

                    <p-button type="button"
                              severity="secondary"
                              icon="pi pi-refresh"
                              label="Clear"
                              (click)="resetSearchProc()"
                              class="ui-button-plain buttonWidth-8 fl"></p-button>
                </div>
            </div>
        </div>

        <p-table [value]="diagsummary?.data"
                 [columns]="proccols"
                 selectionMode="single"
                 (onRowSelect)="onRowSelectProc($event)"
                 class="col-12">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                        {{ col.header }}
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr [pSelectableRow]="rowData">
                    <td *ngFor="let col of columns" [hidden]="col.hidden">
                        {{ rowData[col.field] }}
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage" let-columns="columns">
                <tr>
                    <td colspan="12" class="Colspan-Bg">
                        <div class="w-12 bg-white">
                            <div class="" style="text-align: center">
                                <img _ngcontent-ng-c683320295=""
                                     class="profile-image"
                                     style="border-radius: 50%; width: 10rem; padding-top: 1rem"
                                     src="assets/imagesNew/table_error.png" />
                            </div>
                            <hr style="margin-bottom: 0.5rem" />
                            <div class=""
                                 style="text-align: center; font-size: larger; color: #1d428f">
                                <i>No records found</i>
                            </div>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>

        <div *ngIf="diagsummary?.data && diagsummary.data.length > 0">
            <p-footer style="display: flex; justify-content: center">
                <button pButton
                        type="button"
                        icon="pi pi-times-circle"
                        (click)="procedure_displaypopup = false"
                        label="Cancel"
                        class="p-button-plain"></button>
            </p-footer>
        </div>
    </p-dialog>
</p-tabView>
